module.exports = __webpack_public_path__ + "img/bottom_inform.f6ed4d15.jpg";